import { Box, Grid } from "@mui/material";
import { useComment } from "@platformx/authoring-apis";
import { CommentWrapper } from "@platformx/comment-review";
import { ErrorMessageHandle } from "@platformx/schema-based-content-type";
import { CommonBoxWithNumber, TitleSubTitle } from "@platformx/utilities";
import { XImageRender } from "@platformx/x-image-render";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useCustomStyle } from "../quiz.style";

const ImageVideo = ({ state, setState, quizRef, unsavedChanges, isError, setIsError }) => {
  const { t } = useTranslation();
  const { scrollToRef } = useComment();

  const updateField = (updatedPartialObj) => {
    const gcbPath = updatedPartialObj?.original_image?.original_image_relative_path;
    const gcbExt = updatedPartialObj?.original_image?.ext;
    const relativeUrl = gcbPath ? `${gcbPath}.${gcbExt}` : "";

    const modifiedData = {
      ...structuredClone(state),
      ...updatedPartialObj,
      thumbnailURL: relativeUrl,
      socialShareImgURL: relativeUrl, //when we update image socialshareimg also needs to update
      notification_image: relativeUrl, //when we update image notification_image also needs to update
      imagevideoURL: relativeUrl, //for validation
      colorCode: "",
    };
    setState(modifiedData);
    setIsError({ ...isError, imageVideo: false });
    quizRef.current = {
      ...quizRef.current,
      ...updatedPartialObj,
      thumbnailURL: relativeUrl,
      socialShareImgURL: relativeUrl, //when we update image socialshareimg also needs to update
      notification_image: relativeUrl, //when we update image notification_image also needs to update
      imagevideoURL: relativeUrl, //for validation
      colorCode: "",
    };
    unsavedChanges.current = true;
  };

  const handleRefresh = () => {
    setState({
      ...state,
      imagevideoURL: "",
      socialShareImgURL: "",
      notification_image: "",
      colorCode: "",
      thumbnailURL: "",
      original_image: {},
      published_images: [],
    });
    quizRef.current = {
      ...quizRef.current,
      imagevideoURL: "",
      socialShareImgURL: "",
      notification_image: "",
      colorCode: "",
      thumbnailURL: "",
      original_image: {},
      published_images: [],
    };
  };

  const handleColorPallete = (color) => {
    setState({
      ...state,
      imagevideoURL: "",
      thumbnailURL: "",
      socialShareImgURL: "",
      notification_image: "",
      original_image: {},
      published_images: [],
      colorCode: color,
    });
    setIsError({ ...isError, imageVideo: false });
    quizRef.current = {
      ...quizRef.current,
      imagevideoURL: "",
      thumbnailURL: "",
      socialShareImgURL: "",
      notification_image: "",
      colorCode: color,
    };
    unsavedChanges.current = true;
  };

  const classes = useCustomStyle();
  return (
    <Box id='imageVideo' className={classes.mainStyleWrapper}>
      <CommentWrapper elementId='2' scrollRef={scrollToRef}>
        <CommonBoxWithNumber
          number='02'
          title={t("quiz_background_head")}
          titleVarient='h5bold'
          subTitleVarient='p4regular'
          subTitle={t("subhead")}>
          <Grid container>
            <Grid item xs={12} sm={5} md={5} className='leftFiledLast'>
              <TitleSubTitle
                title={`${t("add_image")}*`}
                subTitle={t("quiz_image_subtitle")}
                titleVariant='h6medium'
                subTitleVariant='p4regular'
              />
            </Grid>
            <Grid item xs={12} sm={7} md={7} className='textFiledLast'>
              <XImageRender
                callBack={updateField}
                editData={{
                  original_image: state.original_image,
                  published_images: state.published_images,
                  isImg: !state.colorCode,
                  colorCode: state.colorCode,
                }}
                isColorPallete={true}
                handleRefresh={handleRefresh}
                handleColorPallete={handleColorPallete}
              />
              {isError["imageVideo"] && (
                <ErrorMessageHandle error={{ message: "Field is Required" }} />
              )}
            </Grid>
          </Grid>
        </CommonBoxWithNumber>
      </CommentWrapper>
    </Box>
  );
};

export default memo(ImageVideo);
